export default {"src":"/_next/static/media/circle_flag1.91f37a5c.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};